import { ABOUT_SCROLL_TO_START, ABOUT_SECTION_IN_VIEW } from 'events';
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const { pageButton = [], sectionButton = [], activeSectionLabel = [] } = choozy(node);

  const pageButtons = [].concat(pageButton);
  const sectionButtons = [].concat(sectionButton);
  const activeSectionLabels = [].concat(activeSectionLabel);

  const { pageHandle } = node.dataset;

  let activeSection = null;

  const init = () => {
    sectionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const slide = document
          .getElementById(button.dataset.sectionButton)
          .closest('.shopify-section');

        slide.scrollIntoView({ behavior: 'smooth' });
      });
    });

    pageButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        if (button.dataset.pageButton === pageHandle) {
          e.preventDefault();
          ctx.emit(ABOUT_SCROLL_TO_START);
        }
      });
    });
  };

  const updateButtons = () => {
    if (activeSection) {
      pageButtons.forEach((buttonGroup) => {
        buttonGroup.classList.remove('active');
      });

      sectionButtons.forEach((buttonGroup) => {
        if (buttonGroup.dataset.sectionButton === activeSection.id) {
          buttonGroup.classList.add('active');

          if (activeSectionLabels && activeSectionLabels.length > 0) {
            activeSectionLabels.forEach((label) => {
              label.textContent = buttonGroup.dataset.sectionButtonLabel;
            });
          }
        } else {
          buttonGroup.classList.remove('active');
        }
      });
    } else {
      sectionButtons.forEach((buttonGroup) => {
        buttonGroup.classList.remove('active');
      });

      pageButtons.forEach((buttonGroup) => {
        if (buttonGroup.dataset.pageButton === pageHandle) {
          buttonGroup.classList.add('active');

          if (activeSectionLabels && activeSectionLabels.length > 0) {
            activeSectionLabels.forEach((label) => {
              label.textContent = buttonGroup.dataset.pageButtonLabel;
            });
          }
        } else {
          buttonGroup.classList.remove('active');
        }
      });
    }
  };

  // Needs to be fixed
  ctx.on(ABOUT_SECTION_IN_VIEW, (_, { index, id }) => {
    if (sectionButtons.find((button) => button.dataset.sectionButton === id)) {
      activeSection = { index, id };

      updateButtons();
    } else if (activeSection !== null && index < activeSection.index) {
      activeSection = null;

      updateButtons();
    }
  });

  init();
});
